
import { AuthProviderIdentifier } from "@api-commons/login/AuthProviderIdentifier";
import { CpNativeAppUpstreamBridge, GetStoredSessionResponse, NativeAppLoginResponse, NotificationDeviceInfo, ProposeSubscriptionResponse } from "../CpNativeAppIntegration.js";
import { Logger } from "@ciaopeople/cp-shatsu/Logging";
import { StorableSession } from "@api-commons/session/StorableSession";

export class DummyCpNativeAppUpstreamBridge implements CpNativeAppUpstreamBridge {
    
    constructor(private logger: Logger) {
        
    }
    getStoredSession(): Promise<GetStoredSessionResponse> {
        return Promise.reject("Impossible to call getStoredSession on DummyCpNativeAppUpstreamBridge");
    }
    logoutExecuted(): void {
        this.logger.debug("Called DummyCpNativeAppUpstreamBridge::logoutExecuted");
    }
    personalDataDeletionCompleted(): void {
        this.logger.debug("Called DummyCpNativeAppUpstreamBridge::personalDataDeletionCompleted");
    }
    
    resolveCallback(callbackId: string, data?: any): void {
        this.logger.debug("Called DummyCpNativeAppUpstreamBridge::resolveCallback", callbackId, data);
    }
    requireLogin(provider_suggestion: AuthProviderIdentifier): Promise<NativeAppLoginResponse> {
        this.logger.debug("Called DummyCpNativeAppUpstreamBridge::requireLogin", provider_suggestion);
        return Promise.reject("Impossible to login this is a dummy implentation");
    }
    requireFacebookLogin(): void {
        this.logger.debug("Called DummyCpNativeAppUpstreamBridge::requireFacebookLogin");
    }
    requireNotificationEnable(): void {
        this.logger.debug("Called DummyCpNativeAppUpstreamBridge::requireNotificationEnable");
    }
    shareUrl(title: string, url: string): void {
        this.logger.debug("Called DummyCpNativeAppUpstreamBridge::shareUrl", title, url);
    }
    sessionChange(session: StorableSession, device: string): void {
        this.logger.debug("Called DummyCpNativeAppUpstreamBridge::sessionChange", session, device);
    }
    getNotificationDeviceInfo(): Promise<NotificationDeviceInfo> {
        return Promise.reject("Impossible to call getNotificationDeviceInfo on DummyCpNativeAppUpstreamBridge");
    }

    proposeSubscription(): Promise<ProposeSubscriptionResponse> {
        return Promise.reject("Impossible to call proposeSubscription on DummyCpNativeAppUpstreamBridge");
    }

    setAnalyticsUserProperties(kmap: {[k: string]: string|number|null}): void {
        this.logger.debug("Called DummyCpNativeAppUpstreamBridge::setAnalyticsUserProperties", kmap);
    }

}